import {Component, Injector, OnDestroy, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {Router} from '@angular/router';
import {AbpMultiTenancyService, AbpSessionService} from 'abp-ng2-module';
import {AppAuthService} from '@app/shared/common/auth/app-auth.service';
import {LinkedAccountService} from '@app/shared/layout/linked-account.service';
import {AppConsts} from '@shared/AppConsts';
import {ThemesLayoutBaseComponent} from '@app/shared/layout/themes/themes-layout-base.component';
import {
    ChangeUserLanguageDto,
    LinkedUserDto,
    OrganizationUnitDto,
    ProfileServiceProxy,
    UserLinkServiceProxy,
    UserOrganizationUnitsDto,
    UserServiceProxy,
    VirtualBankAccountDto,
    VirtualBankServiceProxy
} from '@shared/service-proxies/service-proxies';
import * as _ from 'lodash-es';

import {WebshopService} from '@app/shared/common/shop-system/services/webshop.service';


import {tap} from 'rxjs/operators';
import {ImpersonationService} from '@app/admin/users/impersonation.service';
import {BaseModalComponent} from '@app/shared/common/modals/base-modal/base-modal.component';
import {AxillaPackage} from '../common/shop-system/models/models';
import {Observable} from 'rxjs';
import {FieldAgentService} from '@app/webshop/field-agent/shared/services/field-agent.service';
import {FeatureDefinition} from '@shared/features/base-features-definitions';

@Component({
    templateUrl: './topbar.component.html',
    selector: 'topbar',
    encapsulation: ViewEncapsulation.None
})

export class TopBarComponent extends ThemesLayoutBaseComponent implements OnInit, OnDestroy {
    protected readonly FeatureDefinition = FeatureDefinition;

    isHost = false;
    languages: abp.localization.ILanguageInfo[];
    currentLanguage: abp.localization.ILanguageInfo;
    isImpersonatedLogin = false;
    isMultiTenancyEnabled = false;
    shownLoginName = '';
    tenancyName = '';
    userName = '';
    profilePicture = AppConsts.appBaseUrl + '/assets/common/images/default-profile-picture.png';
    defaultLogo = AppConsts.appBaseUrl + '/assets/common/images/app-logo-on-' + this.currentTheme.baseSettings.menu.asideSkin + '.svg';
    recentlyLinkedUsers: LinkedUserDto[];
    unreadChatMessageCount = 0;
    remoteServiceBaseUrl: string = AppConsts.remoteServiceBaseUrl;
    chatConnected = false;
    isQuickThemeSelectEnabled: boolean = this.setting.getBoolean('App.UserManagement.IsQuickThemeSelectEnabled');
    @ViewChild('appBaseModal', {static: true}) notAuthModal: BaseModalComponent;
    ous: UserOrganizationUnitsDto;
    ddOus: any;
    selectedOu: any;

    // #region USER OU
    virtualBankAccount?: VirtualBankAccountDto;
    favoritesCounterUpdatetSubscription$;
    basketCounterUpdatetSubscription$;
    packageUpdatetSubscription$;

    constructor(
        injector: Injector,
        private _abpSessionService: AbpSessionService,
        private _abpMultiTenancyService: AbpMultiTenancyService,
        private _profileServiceProxy: ProfileServiceProxy,
        private _userLinkServiceProxy: UserLinkServiceProxy,
        private _authService: AppAuthService,
        private _linkedAccountService: LinkedAccountService,
        private _userServiceService: UserServiceProxy,
        private _impersonationService: ImpersonationService,
        private _webshopService: WebshopService,
        private _fieldAgentService: FieldAgentService,
        private _router: Router
    ) {
        super(injector);
    }

    get ifUserHasOu(): boolean {
        if (!this.ous) {
            return false;
        }

        return this.ifUserCanSelectOU && this.ifUserHasSelectedOu && this.ifUserInOU;
    }

    get isBlocked(): boolean {
        return this._webshopService.isOuBlocked;
    }

    //#region Favorites
    private _favoritesItemsCount = 0;

    get favoritesItemsCount(): number {
        return this._favoritesItemsCount;
    }

    set favoritesItemsCount(count: number) {
        this._favoritesItemsCount = count;
    }

    // #endregion USER OU

    get isWebshopAvailable(): boolean {
        //return this.permission.isGranted('Pages.App.PunchOut.View');
        return true;
    }

    private _itemsCount = 0;

    //#region Webshop

    //#region isBlocked

    get itemsCount(): number {
        return this._itemsCount;
    }

    set itemsCount(count: number) {
        this._itemsCount = count;
    }

    //#endregion isBlocked

    get totalItemAmount(): number {
        return this._webshopService.totalItemAmount;
    }

    //#region Minimum amount
    get minimumAmount(): number {
        return this._webshopService.minimumAmount;
    }

    get isAmountFitMinimumAmountRequirements(): boolean {
        return this._webshopService.checkMinimumAmountRequirements();
    }

    //#region Package
    private _package: AxillaPackage;

    get package(): AxillaPackage {
        return this._package;
    }

    set package(value: AxillaPackage) {
        this._package = value;
    }

    //#endregion Favorites

    get packagePallets() {
        return _.reverse(this.package.pallets);
    }

    get isLinkAccountEnable() {
        let isEnabled = abp.features.isEnabled('App.Beta.Menu.LinkAccount');
        return isEnabled;
    }

    private get ifUserHasSelectedOu(): boolean {
        if (this.selectedOu == null || this.selectedOu === 0 || this.selectedOu === undefined) {
            return false;
        }

        if (this.selectedOu != null && this.ous.organizationUnits.length === 1) {
            return false;
        }

        if (this.selectedOu != null && this.selectedOu > 0) {
            return true;
        }

        return false;
    }

    private get ifUserInOU(): boolean {
        if (this.ous.organizationUnits != null && this.ous.organizationUnits.length <= 1) {
            return false;
        }

        if (this.ous.organizationUnits != null && this.ous.organizationUnits.length >= 1) {
            return true;
        }

        return false;
    }

    private get ifUserCanSelectOU(): boolean {
        if (this.ous.organizationUnits != null && this.ous.organizationUnits.length === 1 && this.selectedOu == null) {
            return true;
        }

        if (this.ous.organizationUnits != null && this.ous.organizationUnits.length >= 1) {
            return true;
        }

        return false;
    }

    ngOnInit() {

        this.isHost = !this._abpSessionService.tenantId;
        this.isMultiTenancyEnabled = this._abpMultiTenancyService.isEnabled;
        this.languages = _.filter(this.localization.languages, l => (l).isDisabled === false);
        this.currentLanguage = this.localization.currentLanguage;
        this.isImpersonatedLogin = this._abpSessionService.impersonatorUserId > 0;
        this.setCurrentLoginInformations();
        this.getProfilePicture();
        this.getRecentlyLinkedUsers();

        this.registerToEvents();

        this._onBasketUpdate();
        this._onFavoritesUpdate();
        this._onPackageUpdate();

        this._getUserVB();
        this._getUserOus();

        //if (!(abp.session.userId > 0)) {
        //    abp.event.trigger('app.show.notAuthModal');
        //}
    }

    ngOnDestroy(): void {
        this.basketCounterUpdatetSubscription$.unsubscribe();
        this.favoritesCounterUpdatetSubscription$.unsubscribe();
    }

    changeOu(ou: number) {
        this._changeOu$(ou)
            .subscribe(() => {

            });
    }

    checkIsBlocked() {
        this._webshopService.isBlocked$()
            .subscribe((result) => {
                window.location.reload();
            });
    }

    goToFavorites() {
        this._router.navigate(['/app/webshop/favorites']);
    }

    //#endregion Minimum amount

    goToBasket() {
        this.webshopService.goToBasket();
    }

    registerToEvents() {
        abp.event.on('profilePictureChanged', () => {
            this.getProfilePicture();
        });

        abp.event.on('app.chat.unreadMessageCountChanged', messageCount => {
            this.unreadChatMessageCount = messageCount;
        });

        abp.event.on('app.chat.connected', () => {
            this.chatConnected = true;
        });

        abp.event.on('app.getRecentlyLinkedUsers', () => {
            this.getRecentlyLinkedUsers();
        });
    }

    changeLanguage(languageName: string): void {
        const input = new ChangeUserLanguageDto();
        input.languageName = languageName;

        this._profileServiceProxy.changeLanguage(input).subscribe(() => {
            abp.utils.setCookieValue(
                'Abp.Localization.CultureName',
                languageName,
                new Date(new Date().getTime() + 5 * 365 * 86400000), //5 year
                abp.appPath
            );

            window.location.reload();
        });
    }

    setCurrentLoginInformations(): void {
        this.tenancyName = this.appSession.tenancyName;
        if (abp.session.userId > 0) {
            this.shownLoginName = this.appSession.getShownLoginName();
            this.userName = this.appSession.user.userName;
        }
    }

    getShownUserName(linkedUser: LinkedUserDto): string {
        if (!this._abpMultiTenancyService.isEnabled) {
            return linkedUser.username;
        }

        return (linkedUser.tenantId ? linkedUser.tenancyName : '.') + '\\' + linkedUser.username;
    }

    getProfilePicture(): void {
        if (abp.session.userId != null) {
            this._profileServiceProxy.getProfilePicture().subscribe(result => {
                if (result && result.profilePicture) {
                    this.profilePicture = 'data:image/jpeg;base64,' + result.profilePicture;
                }
            });
        }

    }

    //#endregion Package

    //#endregion

    getRecentlyLinkedUsers(): void {
        if (abp.session.userId != null) {
            this._userLinkServiceProxy.getRecentlyUsedLinkedUsers().subscribe(result => {
                this.recentlyLinkedUsers = result.items;
            });
        }
    }

    showLoginAttempts(): void {
        abp.event.trigger('app.show.loginAttemptsModal');
    }

    showLinkedAccounts(): void {
        abp.event.trigger('app.show.linkedAccountsModal');
    }

    changePassword(): void {
        abp.event.trigger('app.show.changePasswordModal');
    }

    changeProfilePicture(): void {
        abp.event.trigger('app.show.changeProfilePictureModal');
    }

    getSession() {
        if (abp.session.userId > 0) {
            return true;
        }
        return false;
    }

    logout(): void {
        this._authService.logout();
    }

    login(): void {
        abp.event.trigger('app.show.loginModal');
        //this._router.navigate([AppRouteGuard.loginUrl]);
    }

    backToMyAccount(): void {
        this._impersonationService.backToImpersonator();
    }

    switchToLinkedUser(linkedUser: LinkedUserDto): void {
        this._linkedAccountService.switchToAccount(linkedUser.id, linkedUser.tenantId);
    }

    downloadCollectedData(): void {
        this._profileServiceProxy.prepareCollectedData().subscribe(() => {
            this.message.success(this.l('GdprDataPrepareStartedNotification'));
        });
    }

    getCurrency() {
        return this._webshopService.getCurrency();
    }

    changeMySettings(): void {
        abp.event.trigger('app.show.mySettingsModal');
    }

    private _getUserOus() {
        let label = abp.localization.localize('Axilla.User.SelectOu', 'Axilla');
        this.ddOus = [{label: label, value: null}];
        this._webshopService._getUserOus$()
            .subscribe((data: UserOrganizationUnitsDto) => {
                this.ous = data;
                this.selectedOu = data.selectedOu;

                _.each(this.ous.organizationUnits,
                    (ou: OrganizationUnitDto) => {
                        this.ddOus.push({
                            label: ou.displayName,
                            value: ou.id
                        });
                    });
            });
    }

    private _changeOu$(ou: number): Observable<void> {
        return this._userServiceService.setCurrentOu(ou)
            .pipe(
                tap(() => {
                    this.checkIsBlocked();
                })
            );
    }

    private _getUserVB() {
        if (abp.session.userId > 0) {
            this._fieldAgentService.getVirtualBankAccountByUser$(abp.session.userId)
                .subscribe((result: VirtualBankAccountDto) => {
                    this.virtualBankAccount = result;
                });
        }
    }

    private _onFavoritesUpdate() {
        this.favoritesCounterUpdatetSubscription$ = this._webshopService.favoritesCounterUpdate$
            .subscribe((count: number) => {
                this.favoritesItemsCount = count;
            });
    }

    private _onBasketUpdate() {
        this.basketCounterUpdatetSubscription$ = this._webshopService.basketCounterUpdate$
            .subscribe((count: number) => {
                this.itemsCount = count;
            });
    }

    private _onPackageUpdate() {
        this.packageUpdatetSubscription$ = this._webshopService.packageUpdate$
            .subscribe((axillaPackage: AxillaPackage) => {
                this.package = axillaPackage;
            });
    }

}
